import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { UserMenuComponent } from './user-menu/user-menu.component';

@Component({
  selector: 'app-header',
  imports: [UserMenuComponent],
  templateUrl: './header.html',
  styleUrl: './header.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  readonly menuToggle = output<void>();

  protected onMenuToggle() {
    this.menuToggle.emit();
  }
}
